export default "__VITE_ASSET__2764f910__"